import {
    ApiContentSection,
    ApiFullLandingPageLink,
    ApiSectionType,
} from '@storefronts/common-types'
import { ReactNode } from 'react'

export type SectionRenderContext = {
    index: number
    compact?: boolean
    reviewsProductLink?: ApiFullLandingPageLink
    isBelowFold: boolean
    prioritizeImages: boolean
    sectionRef: (el: HTMLDivElement | null) => void
    stampInspectAttrs: boolean
    showRecentlyViewed: boolean
}

type SectionRenderer = (
    section: ApiContentSection,
    ctx: SectionRenderContext,
) => ReactNode

const renderers = new Map<ApiSectionType, SectionRenderer>()

export const registerSection = <T extends ApiSectionType>(
    type: T,
    render: (
        section: Extract<ApiContentSection, { type: T }>,
        ctx: SectionRenderContext,
    ) => ReactNode,
) => {
    renderers.set(type, render as SectionRenderer)
}

export const renderSection = (
    section: ApiContentSection,
    ctx: SectionRenderContext,
): ReactNode => renderers.get(section.type)?.(section, ctx) ?? null
